import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import { MoveUserPool } from '../userpool';
import {BETA_LINK_URL, FAST_SRV} from "../common/constants";
import {postData} from "../common/api";
import useCognitoSessionCheck from "../hooks/useCognitoSessionCheck";

const FastLink = () => {

  const [link, setLink] = useState('#');
  const [buttonStyle, setButtonStyle] = useState('button isDisabled');

  const navigate = useNavigate();

  useCognitoSessionCheck(MoveUserPool, "fast", 60000);  // Check session is not expired every 60 seconds

  useEffect(()=>{
    let user= MoveUserPool.getCurrentUser();
    console.log(user);
    if(!user){
      navigate('/login', {state: {from: "fast"}});
    }
    const asyncFn = async() => postData(BETA_LINK_URL, {srv: FAST_SRV})
      .then((data) => {
        setLink(data.link);
        setButtonStyle("button isEnabled")
    });
    asyncFn();
  },[navigate]);

  return (
    <div class="container">
      <img class="logo" src="logo.png" alt="Logo" width="200" height="100"/>
      <h1 class="header">!Feezback Fast-ברוכים הבאים ל</h1>
      <p class="text">תודה לכם שהסכמתם לעזור לנו לבדוק את השירות החדש שלנו שיאפשר לאנשים לבצע הפקדות לחסכונות שלהם באופן קל ופשוט. התהליך כולל שני שלבים פשוטים, הראשון, הגדרת פרטי החשבון ( זה לא נשמר בשום מקום במערכות שלנו ), ולאחר מכן נבקש מכן לאשר העברה של 1 ש״ח. בשלב הבדיקות הכסף מועבר לחשבון הבנק של פיזבק. לאחר ביצוע ההעברה נבצע אליכם החזר כמובן.</p>
          <a href={link} className={buttonStyle} id="link-href">{link !== "#" ? "בואו נתחיל" : "...אנא  המתן לטעינת האפליקציה של פיזבק"}</a>
      <p>
      <a href="https://www.feezback.com" target="_blank">פרטים על פיזבק</a></p>
  </div>
  )
}

export default FastLink;
